<!--
  R16b · the artefacts of a turn, as chips under the answer.

  These are the rows' `summary` values, lifted out of the thinking chain on purpose: a diagnosis
  Maya opened and a file the customer attached are the same kind of object to the reader, so they
  get the same shape and the same click (trace_ui_research "跨产品共性 5"). Leaving them inside the
  chain means the one durable thing a turn produced disappears the moment the chain folds.

  A chip with a known destination navigates; one without is a plain label, not a dead button.
-->
<template>
  <div v-if="chips.length" class="mtr-chips" :aria-label="label">
    <component
      :is="chip.view ? 'button' : 'span'"
      v-for="(chip, index) in chips"
      :key="chip.label + index"
      :type="chip.view ? 'button' : undefined"
      class="mtr-chip"
      :class="{ 'mtr-chip-flat': !chip.view }"
      @click="chip.view && emit('open', chip)"
    >{{ chip.label }}</component>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "../useI18n";
import { traceChips } from "../composables/useMayaTrace";

const { t } = useI18n();
const props = defineProps({ rows: { type: Array, default: () => [] } });
const emit = defineEmits(["open"]);

const chips = computed(() => traceChips(props.rows));
const label = computed(() => t("maya_trace_artifacts"));
</script>

<style>
.mtr-chips { display: flex; flex-wrap: wrap; gap: 6px; margin: 6px 0 2px;  /* flush with the bubble: .mcol already supplies the avatar gutter */ max-width: 100%; min-width: 0; }
.mtr-chip { display: inline-flex; align-items: center; gap: 6px; max-width: 100%; overflow-wrap: anywhere; text-align: left; color: var(--body); background: var(--card); border: 1px solid var(--line); border-radius: 7px; padding: 4px 9px; font: inherit; font-size: var(--fs-caption2); cursor: pointer; transition: transform .1s ease-out, border-color .15s ease-out; animation: mtr-up .3s cubic-bezier(.23, 1, .32, 1) both; }
.mtr-chip::before { content: ""; width: 5px; height: 5px; border-radius: 1.5px; background: var(--indigo); flex: 0 0 auto; }
.mtr-chip:hover { border-color: var(--tint-line, var(--indigo)); }
.mtr-chip:active { transform: scale(.97); }
.mtr-chip:focus-visible { outline: 3px solid var(--indigo); outline-offset: 2px; }
.mtr-chip-flat { cursor: default; color: var(--mute); }
.mtr-chip-flat::before { background: var(--mute); opacity: .6; }
@media (prefers-reduced-motion: reduce) {
  .mtr-chip { animation: none; transition-duration: .01ms; }
}
</style>
